<template>
  <v-layout row>
    <v-flex xs12>
      <v-toolbar color="blue-grey">
        <v-toolbar-title>Post</v-toolbar-title>
      </v-toolbar>
      <v-card>
        <form>
            <v-textarea
                v-model="story"
                :error-messages="storyErrors"
                label="Story"
                required
                @input="$v.story.$touch()"
                @blur="$v.story.$touch()"
            ></v-textarea>
            <vue-dropzone
                id="dropzone"
                ref="dropzone"
                :options="dropzoneOptions"
                v-on:vdropzone-file-added="upload"
                v-on:vdropzone-files-added="upload"
                v-on:vdropzone-sending="sendingEvent"
                class="blue-grey lighten-3"
            ></vue-dropzone>
            <draggable
                :options="{handle: '.dz-drag'}"
                class="dropzone-previews vue-dropzone dropzone blue-grey lighten-2"
            ></draggable>
            <v-btn @click="submit" :disabled="submitDisabled">submit</v-btn>
        </form>
        <v-snackbar
          v-model="snackbar"
          color="error"
          :timeout="10000"
          :top="true"
        >
          {{ error }}
          <v-btn
            dark
            flat
            @click="snackbar = false"
          >
            Close
          </v-btn>
        </v-snackbar>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
  import vue2Dropzone from 'vue2-dropzone'
  import 'vue2-dropzone/dist/vue2Dropzone.min.css'
  import { validationMixin } from 'vuelidate'
  import { required } from 'vuelidate/lib/validators'
  import draggable from 'vuedraggable'
  
  export default {
    props: ['challenge'],
    components: {
        vueDropzone: vue2Dropzone,
        draggable
    },
    mixins: [validationMixin],
    validations: {
      story: { required }
    },
    data () {
      return {
        snackbar: false,
        error: "",
        submitDisabled: false,
        post: {},
        story: '',
        dropzoneOptions: {
          url: 'https://api.nipchallenge.com/upload',
          acceptedFiles: 'image/*,video/*',
          paramName: 'files',
          autoProcessQueue: false,
          addRemoveLinks: true,
          parallelUploads: 1,
          maxFilesize: 10000,
          previewsContainer: ".dropzone-previews",
          dictDefaultMessage: "Drop files or click here to upload",
          headers: {
            Authorization: `Bearer ${this.$http.api.jwt}`,
            'Cache-Control': null,
            'X-Requested-With': null
          },
          previewTemplate: '<div class="dz-preview dz-file-preview"><div class="dz-image"><img data-dz-thumbnail /></div><div class="dz-drag blue lighten-3"><i class="v-icon material-icons theme--dark grey--text text--darken-2" style="font-size: 36px;">drag_handle</i></div><div class="dz-details"><div class="dz-size"><span data-dz-size></span></div><div class="dz-filename"><span data-dz-name></span></div></div><div class="dz-progress"><span class="dz-upload" data-dz-uploadprogress></span></div><div class="dz-error-message"><span data-dz-errormessage></span></div><div class="dz-success-mark"><svg width="54px" height="54px" viewBox="0 0 54 54" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:sketch="http://www.bohemiancoding.com/sketch/ns"><title>Check</title><defs></defs><g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" sketch:type="MSPage"><path d="M23.5,31.8431458 L17.5852419,25.9283877 C16.0248253,24.3679711 13.4910294,24.366835 11.9289322,25.9289322 C10.3700136,27.4878508 10.3665912,30.0234455 11.9283877,31.5852419 L20.4147581,40.0716123 C20.5133999,40.1702541 20.6159315,40.2626649 20.7218615,40.3488435 C22.2835669,41.8725651 24.794234,41.8626202 26.3461564,40.3106978 L43.3106978,23.3461564 C44.8771021,21.7797521 44.8758057,19.2483887 43.3137085,17.6862915 C41.7547899,16.1273729 39.2176035,16.1255422 37.6538436,17.6893022 L23.5,31.8431458 Z M27,53 C41.3594035,53 53,41.3594035 53,27 C53,12.6405965 41.3594035,1 27,1 C12.6405965,1 1,12.6405965 1,27 C1,41.3594035 12.6405965,53 27,53 Z" id="Oval-2" stroke-opacity="0.198794158" stroke="#747474" fill-opacity="0.816519475" fill="#FFFFFF" sketch:type="MSShapeGroup"></path></g></svg></div><div class="dz-error-mark"><svg width="54px" height="54px" viewBox="0 0 54 54" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:sketch="http://www.bohemiancoding.com/sketch/ns"><title>Error</title><defs></defs><g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" sketch:type="MSPage"><g id="Check-+-Oval-2" sketch:type="MSLayerGroup" stroke="#747474" stroke-opacity="0.198794158" fill="#FFFFFF" fill-opacity="0.816519475"><path d="M32.6568542,29 L38.3106978,23.3461564 C39.8771021,21.7797521 39.8758057,19.2483887 38.3137085,17.6862915 C36.7547899,16.1273729 34.2176035,16.1255422 32.6538436,17.6893022 L27,23.3431458 L21.3461564,17.6893022 C19.7823965,16.1255422 17.2452101,16.1273729 15.6862915,17.6862915 C14.1241943,19.2483887 14.1228979,21.7797521 15.6893022,23.3461564 L21.3431458,29 L15.6893022,34.6538436 C14.1228979,36.2202479 14.1241943,38.7516113 15.6862915,40.3137085 C17.2452101,41.8726271 19.7823965,41.8744578 21.3461564,40.3106978 L27,34.6568542 L32.6538436,40.3106978 C34.2176035,41.8744578 36.7547899,41.8726271 38.3137085,40.3137085 C39.8758057,38.7516113 39.8771021,36.2202479 38.3106978,34.6538436 L32.6568542,29 Z M27,53 C41.3594035,53 53,41.3594035 53,27 C53,12.6405965 41.3594035,1 27,1 C12.6405965,1 1,12.6405965 1,27 C1,41.3594035 12.6405965,53 27,53 Z" id="Oval-2" sketch:type="MSShapeGroup"></path></g></g></svg></div></div>'
        }
    }
  },
    computed: {
        storyErrors () {
            const errors = []
            if (!this.$v.story.$dirty) return errors
            !this.$v.story.required && errors.push('Story is required.')
            return errors
        },
    },
    methods: {
        sendingEvent (file, xhr, formData) {
            formData.append('refId', this.post.id);
            formData.append('ref', 'post');
            formData.append('field', 'media');
        },
        submit () {
            //if (this.$refs['dropzone'].getAcceptedFiles().length < 1)
            this.submitDisabled = true;

            this.$http.api.post('/posts', {
                challenge: this.challenge,
                story: this.story
            })
            .then((post) => {
                this.post = post.data;

                this.upload();
            })
        .catch(error => {
            this.submitDisabled = false;
            
            if (error.response) {
                this.error = this.$http.api.getError(error).toString;
                this.snackbar = true;
            }
            else {
                console.dir(error);
            }
        });
        },
        upload () {
            if (this.post.id) {
                this.$refs['dropzone'].processQueue();
            }
        }
    },
    created () {
        this.$http.api.checkLogin();
    }
  }
</script>

<style>
.dropzone {
  min-height: 0;
  padding: 0;
}
.dz-drag {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 100000;
  opacity: 0.8;
  cursor: move;
}
.dz-progress {
  opacity: 0.8 !important;
}
</style>